(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sprouht-pdp-video')) return;

    const SOUND_KEY = 'sprouht:pdp-video-sound';
    const OPEN_CLASS = 'sp-video-popup-open';

    class SprouhtPdpVideo extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('.sp-video__frame');
        this.videos = Array.from(this.querySelectorAll('.sp-video__media'));
        if (!this.frame || !this.videos.length) return;

        this.playButton = this.querySelector('.sp-video__play');
        this.muteButton = this.querySelector('.sp-video__mute');
        this.expandButton = this.querySelector('.sp-video__expand');
        this.popup = this.popup || this.querySelector('.sp-video-popup');
        this.desktopQuery = window.matchMedia('(min-width: 750px)');

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reducedMotion;
        this.threshold = Math.min(Math.max(parseFloat(this.dataset.threshold) || 0.5, 0.1), 1);
        this.unmuteOnPlay = this.dataset.unmuteOnPlay === 'true';
        this.rememberSound = this.dataset.rememberSound === 'true';
        this.mobilePopup = this.dataset.mobilePopup === 'true';

        this.engaged = false;
        this.userPaused = false;
        this.inView = false;
        this.nearView = false;
        this.inPopup = false;
        this.activeVideo = null;
        this.muted = !(this.rememberSound && this.readSound() === 'on');

        this.handleMediaChange = () => {
          this.closePopup();
          this.setActive();
        };
        this.handleKeydown = (event) => this.onPopupKeydown(event);
        this.desktopQuery.addEventListener('change', this.handleMediaChange);

        if (this.popup && this.popup.parentElement !== document.body) {
          document.body.appendChild(this.popup);
        }

        if (!this.bound) {
          this.bindVideos();
          this.bindControls();
          this.bindPopup();
          this.bound = true;
        }

        this.setActive();
        this.updateMuteButton();
        this.observe();
      }

      disconnectedCallback() {
        this.closePopup();
        if (this.viewObserver) this.viewObserver.disconnect();
        if (this.lazyObserver) this.lazyObserver.disconnect();
        if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.handleMediaChange);
        if (this.popup) this.popup.remove();
        if (this.videos) this.videos.forEach((video) => video.pause());
      }

      bindVideos() {
        this.videos.forEach((video) => {
          video.muted = true;

          video.addEventListener('play', () => {
            if (video !== this.activeVideo) return;
            this.classList.add('is-playing');
            if (this.popup) this.popup.classList.remove('is-paused');
          });

          video.addEventListener('pause', () => {
            if (video !== this.activeVideo) return;
            this.classList.remove('is-playing');
            if (this.popup && this.inPopup) this.popup.classList.add('is-paused');
          });

          video.addEventListener('timeupdate', () => {
            if (video === this.activeVideo && this.inPopup) this.updateProgress();
          });

          video.addEventListener('volumechange', () => {
            if (video !== this.activeVideo || video.muted === this.muted) return;
            this.muted = video.muted;
            this.updateMuteButton();
            this.storeSound();
          });
        });
      }

      bindControls() {
        if (this.playButton) {
          this.playButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.playFromStart();
          });
        }

        if (this.muteButton) {
          this.muteButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggleMute();
          });
        }

        if (this.expandButton) {
          this.expandButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.expand();
          });
        }

        this.frame.addEventListener('click', () => this.handleSurfaceClick());
      }

      bindPopup() {
        if (!this.popup) return;

        this.popupStage = this.popup.querySelector('.sp-video-popup__stage');
        this.popupPlay = this.popup.querySelector('.sp-video-popup__play');
        this.popupClose = this.popup.querySelector('.sp-video-popup__close');
        this.popupMute = this.popup.querySelector('.sp-video-popup__mute');
        this.popupProgress = this.popup.querySelector('.sp-video-popup__progress');
        this.popupFill = this.popup.querySelector('.sp-video-popup__progress-fill');

        this.popup.querySelectorAll('[data-popup-close]').forEach((element) => {
          element.addEventListener('click', () => this.closePopup());
        });

        if (this.popupStage) {
          this.popupStage.addEventListener('click', () => this.togglePopupPlayback());
        }

        if (this.popupMute) {
          this.popupMute.addEventListener('click', () => this.toggleMute());
        }

        if (this.popupProgress) {
          this.popupProgress.addEventListener('click', (event) => this.seekFromPointer(event));
        }

        this.popup.addEventListener(
          'touchstart',
          (event) => {
            const touch = event.touches[0];
            this.touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
          },
          { passive: true }
        );

        this.popup.addEventListener(
          'touchend',
          (event) => {
            if (!this.touchStart) return;
            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - this.touchStart.x;
            const deltaY = touch.clientY - this.touchStart.y;
            this.touchStart = null;
            if (deltaY > 80 && Math.abs(deltaX) < deltaY) this.closePopup();
          },
          { passive: true }
        );
      }

      observe() {
        if (!('IntersectionObserver' in window)) {
          this.inView = true;
          this.nearView = true;
          this.prime();
          this.sync();
          return;
        }

        this.viewObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.inView = entry.isIntersecting && entry.intersectionRatio >= this.threshold - 0.01;
            });
            this.sync();
          },
          { threshold: [0, this.threshold] }
        );

        this.lazyObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.nearView = true;
            this.prime();
            this.lazyObserver.disconnect();
          },
          { rootMargin: '400px 0px' }
        );

        this.viewObserver.observe(this.frame);
        this.lazyObserver.observe(this.frame);
      }

      setActive() {
        const target = this.desktopQuery.matches ? 'desktop' : 'mobile';
        const next =
          this.videos.find((video) => video.dataset.media === 'all' || video.dataset.media === target) ||
          this.videos[0];

        if (next === this.activeVideo) return;

        this.videos.forEach((video) => {
          if (video !== next && !video.paused) video.pause();
        });

        this.activeVideo = next;
        this.classList.toggle('is-playing', !next.paused);
        this.prime();
        this.sync();
      }

      prime() {
        if (this.nearView && this.activeVideo && this.activeVideo.preload === 'none') {
          this.activeVideo.preload = 'metadata';
        }
      }

      sync() {
        const video = this.activeVideo;
        if (!video || this.inPopup) return;

        const shouldPlay = this.inView && !this.userPaused && (this.autoplay || this.engaged);

        if (shouldPlay) {
          this.playVideo(video);
        } else if (!video.paused) {
          video.pause();
        }
      }

      playVideo(video) {
        if (video !== this.activeVideo) return;

        video.muted = this.muted;
        const attempt = video.play();
        if (!attempt || typeof attempt.catch !== 'function') return;

        attempt.catch((error) => {
          if (!error || error.name !== 'NotAllowedError' || video.muted) return;
          this.muted = true;
          video.muted = true;
          this.updateMuteButton();
          video.play().catch(() => {});
        });
      }

      engage() {
        this.engaged = true;
        this.userPaused = false;
        this.classList.add('is-engaged');
        if (this.unmuteOnPlay) this.muted = false;
        this.updateMuteButton();
      }

      playFromStart() {
        const video = this.activeVideo;
        if (!video) return;

        this.engage();

        try {
          video.currentTime = 0;
        } catch (error) {}

        this.playVideo(video);

        if (!this.desktopQuery.matches && this.mobilePopup) this.openPopup();
      }

      expand() {
        const video = this.activeVideo;
        if (!video) return;

        this.engage();
        if (video.paused) this.playVideo(video);
        this.openPopup();
      }

      handleSurfaceClick() {
        const video = this.activeVideo;
        if (!video) return;

        const playing = this.engaged && !video.paused;

        if (!this.desktopQuery.matches && this.mobilePopup) {
          if (playing) {
            this.expand();
          } else {
            this.playFromStart();
          }
          return;
        }

        if (playing) {
          this.userPaused = true;
          video.pause();
          return;
        }

        this.playFromStart();
      }

      openPopup() {
        const video = this.activeVideo;
        if (!video || !this.popup || !this.popupStage || this.inPopup) return;

        const wasPlaying = !video.paused;
        const ratio =
          video.videoWidth && video.videoHeight
            ? video.videoWidth / video.videoHeight
            : this.frame.clientWidth / Math.max(this.frame.clientHeight, 1);

        this.inPopup = true;
        this.lastFocus = document.activeElement;
        this.popup.style.setProperty('--sp-pop-ratio', String(ratio));
        this.popupStage.insertBefore(video, this.popupPlay);
        this.popup.hidden = false;
        this.popup.classList.toggle('is-paused', !wasPlaying && video.paused);
        document.documentElement.classList.add(OPEN_CLASS);
        document.addEventListener('keydown', this.handleKeydown);
        this.updateProgress();

        if (wasPlaying) this.playVideo(video);

        requestAnimationFrame(() => {
          if (this.inPopup) this.popup.classList.add('is-open');
        });

        if (this.popupClose) this.popupClose.focus({ preventScroll: true });
      }

      closePopup() {
        if (!this.inPopup) return;

        const video = this.activeVideo;
        const wasPlaying = video ? !video.paused : false;

        this.inPopup = false;
        this.popup.classList.remove('is-open', 'is-paused');
        this.popup.hidden = true;
        document.documentElement.classList.remove(OPEN_CLASS);
        document.removeEventListener('keydown', this.handleKeydown);

        if (video) this.frame.insertBefore(video, this.playButton);

        this.userPaused = !wasPlaying;
        if (this.isConnected) this.sync();

        if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
          this.lastFocus.focus({ preventScroll: true });
        }
        this.lastFocus = null;
      }

      togglePopupPlayback() {
        const video = this.activeVideo;
        if (!video) return;

        if (video.paused) {
          this.userPaused = false;
          this.playVideo(video);
        } else {
          this.userPaused = true;
          video.pause();
        }
      }

      seekFromPointer(event) {
        const video = this.activeVideo;
        if (!video || !video.duration || !this.popupProgress) return;

        const rect = this.popupProgress.getBoundingClientRect();
        const ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
        video.currentTime = ratio * video.duration;
        this.updateProgress();
      }

      updateProgress() {
        if (!this.popupFill || !this.activeVideo) return;

        const { currentTime, duration } = this.activeVideo;
        const ratio = duration ? Math.min(currentTime / duration, 1) : 0;
        this.popupFill.style.transform = `scaleX(${ratio})`;
      }

      onPopupKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closePopup();
          return;
        }

        if (event.key !== 'Tab' || !this.popup) return;

        const focusable = Array.from(this.popup.querySelectorAll('button')).filter(
          (element) => element.offsetParent !== null
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      toggleMute() {
        this.muted = !this.muted;
        if (this.activeVideo) this.activeVideo.muted = this.muted;
        this.updateMuteButton();
        this.storeSound();
      }

      updateMuteButton() {
        this.classList.toggle('is-muted', this.muted);
        if (this.popup) this.popup.classList.toggle('is-muted', this.muted);

        [this.muteButton, this.popupMute].forEach((button) => {
          if (!button) return;
          const label = this.muted ? button.dataset.labelUnmute : button.dataset.labelMute;
          button.setAttribute('aria-label', label);
        });
      }

      storeSound() {
        if (!this.rememberSound) return;
        try {
          sessionStorage.setItem(SOUND_KEY, this.muted ? 'off' : 'on');
        } catch (error) {}
      }

      readSound() {
        try {
          return sessionStorage.getItem(SOUND_KEY);
        } catch (error) {
          return null;
        }
      }
    }

    customElements.define('sprouht-pdp-video', SprouhtPdpVideo);
  })();

  } catch(e) { console.error(e); }
})();
})();
